import {useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import styles from './Topbar.module.css'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {
	setMode,
	setQuery,
	setNewOnly,
	selectFilters,
	setFullscreen,
	selectFullscreen,
	setRoomsCollapse,
	selectRoomsCollapse,
	selectTotalNewMessageCount
} from '../messageCenterSlice'

const Topbar = () => {
	const dispatch = useDispatch()
	const {query,newOnly} = useSelector(selectFilters)
	const totalNewMessageCount = useSelector(selectTotalNewMessageCount)
	const roomsCollapse = useSelector(selectRoomsCollapse)
	const showFullscreen = useSelector(selectFullscreen)
	const isClient = useSelector(
		state => state.users.current_user.account_type === 'client'
	)
	return (
		<div className={styles.Topbar}>
			<Button 
				onClick={()=>{dispatch(setRoomsCollapse(!roomsCollapse))}}
				variant="outline-light" 
				className= {[
					"mr-1",
					styles.topExpandButton
					].join(' ')}
				size="sm"
			>
				{
					roomsCollapse 
					? <i className="fa fa-angle-double-right" /> 
					: <i className="fa fa-angle-double-left"  />
				}
			</Button>
			<OverlayTrigger placement="right" overlay={
				<Tooltip>
					Show rooms with new messages only
				</Tooltip>
			}>
				<Button 
					style={{flex:'0 0 auto'}}
					onClick={()=>{dispatch(setNewOnly(!newOnly))}}
					variant={newOnly?"light":"outline-light"}
					className="mr-1" 
					size="sm"
				>
					<i className="fas fa-comments"/> {totalNewMessageCount}
				</Button>
			</OverlayTrigger>
			<Form.Control 
				value={query}
				onChange={e=>{
					dispatch(setQuery(e.target.value))
				}}
				style={{background:'#e5e7f5'}} 
				placeholder="search chat" 
				size="sm"
			/>
			{!isClient&&
				<OverlayTrigger overlay={
					<Tooltip>
						Make an announcement or schedule many messages
					</Tooltip>
				}>
					<Button 
						onClick={()=>{
							dispatch(setMode('GROUP'))
						}}
						style={{flex:'0 0 auto'}} 
						variant="outline-light" 
						className="ml-1" 
						size="sm"
					>
						<span className={styles.GroupMessageText}>Broadcast</span> <i className="fas fa-bullhorn"/>
					</Button>
				</OverlayTrigger>
			}
				<OverlayTrigger overlay={
					<Tooltip>
						Toggle fullscreen
					</Tooltip>
				}>
					<Button 
						onClick={()=>{
							dispatch(
								setFullscreen(!showFullscreen))
						}}
						style={{flex:'0 0 auto'}} 
						variant="outline-light" 
						className= {[
							"mr-1",
							styles.fullscreenButton
							].join(' ')}
						size="sm"
					>
					 <i className="fas fa-expand"/>
					</Button>
				</OverlayTrigger>
		</div>
	)
}

export default Topbar